import { render, staticRenderFns } from "./lrd-details.vue?vue&type=template&id=33a75e50&lang=pug"
import script from "./lrd-details.vue?vue&type=script&lang=ts"
export * from "./lrd-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports